import ConfirmationModal from '@/components/modal/ConfirmationModal';
import { useModal } from '@/components/modal/useModal';
import { Button } from '@/components/ui/button';
import { useMutation } from '@tanstack/react-query';
import { Unplug } from 'lucide-react';
import { undeployDevice } from './constants';
import { toast } from 'sonner';
import { useState } from 'react';
import { getUIErrorMessage } from '@/utils/errors';
import { useRevalidator } from 'react-router';

type UndeployDeviceProps = {
	deviceId: number;
};

const UndeployDevice = (props: UndeployDeviceProps) => {
	const { deviceId } = props;
	const { closeModal, isOpen, openModal } = useModal();
	const [error, setError] = useState('');
	const revalidator = useRevalidator();

	const { mutate: mutateUndeployDevice, isPending } = useMutation({
		mutationKey: ['devices'],
		mutationFn: undeployDevice,
		onSuccess: () => {
			closeModal();
			toast.success('Device undeployed successfully');
			setError('');
			revalidator.revalidate();
		},
		onError: (error: Error) => {
			setError(getUIErrorMessage(error));
		}
	});
	return (
		<>
			<Button
				asChild
				variant="outline"
				onClick={openModal}
				className="flex justify-start w-fit cursor-pointer"
				title="Undeploy device"
			>
				<span>
					<Unplug />
					Undeploy device
				</span>
			</Button>

			<ConfirmationModal
				isOpen={isOpen}
				title="Are you sure?"
				body="This action will undeploy the device and remove it from the site."
				handleClose={closeModal}
				handleConfirm={() => mutateUndeployDevice(deviceId)}
				isDisabled={isPending}
				errorMessage={error}
				isLoading={isPending}
			/>
		</>
	);
};

export default UndeployDevice;
